export default __webpack_public_path__ + "static/media/successGreen.6fbc19b3.svg";